import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AdminShell } from "@/components/admin-shell";
import { useRoleGuard } from "@/hooks/use-role-guard";

export const Route = createFileRoute("/admin")({
  head: () => ({
    meta: [
      { title: "Admin - DeckScore" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: AdminLayout,
});

function AdminLayout() {
  const { status, role } = useRoleGuard(["admin", "super_admin"]);
  if (status !== "ok") {
    return (
      <div className="min-h-screen bg-bg grid place-items-center text-ink-secondary">
        Loading…
      </div>
    );
  }
  return (
    <AdminShell role={role}>
      <Outlet />
    </AdminShell>
  );
}
